/**
 * Routes the SPA is allowed to render.
 * Keep this list aligned with apps/ui/nginx/default.conf.template.
 */

const EXACT_ROUTES = new Set([
  '/',
  '/home',
  '/login',
  '/signup',
  '/pricing',
  '/support',
  '/careers',
  '/join-us',
  '/unsubscribe',
  '/terms',
  '/wizard',
  '/integrations',
  '/authenticate',
  '/auth/callback',
  '/docs',
  '/docs/integrations/chrome-extension',
  '/docs/integrations/x-bookmarks',
  '/legal/privacy',
  '/legal/privacy-policy',
  '/legal/terms',
  '/alternatives/mem0',
  '/comparisons/memara-vs-mem0',
  '/comparisons/vector-database-vs-traditional-database',
  '/roadmap',
  '/roadmap/image-memories',
  '/roadmap/audio-memories',
  '/roadmap/video-memories',
  '/integrations/bare-api',
  '/integrations/bare-mcp',
  '/integrations/chatgpt',
  '/integrations/chatgpt-custom-actions',
  '/integrations/chrome-extension',
  '/integrations/claude-desktop',
  '/integrations/cursor',
  '/integrations/dify',
  '/integrations/directory',
  '/integrations/discord',
  '/integrations/github',
  '/integrations/google-workspace',
  '/integrations/ifttt',
  '/integrations/make',
  '/integrations/microsoft-teams',
  '/integrations/n8n',
  '/integrations/notion',
  '/integrations/slack',
  '/integrations/telegram',
  '/integrations/twitter-bookmarks',
  '/integrations/whatsapp',
  '/integrations/whatsapp-basic',
  '/integrations/whatsapp-business',
  '/integrations/x-bookmarks',
  '/integrations/zapier',
  '/billing/success',
  '/billing/cancel',
  '/billing/upgrade',
]);

const PREFIX_ROUTES = [
  '/blog',
  '/dashboard',
  '/analytics',
  '/spaces',
  '/workspace',
  '/settings',
  '/auth',
  '/billing',
];

function normalizePath(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function isKnownAppRoute(pathname: string): boolean {
  const path = normalizePath(pathname);
  if (EXACT_ROUTES.has(path)) {
    return true;
  }
  return PREFIX_ROUTES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}
